import React, { useCallback } from 'react';
import { SodiumWarningProps } from '../../../Interfaces/SodiumWarningProps';
import Button from '../../Atoms/Button/Button';
import { getDaysInYear } from '../../../Utils/componentUtils';
import Modal from '../Modal/Modal';

const SodiumWarning: React.FC<SodiumWarningProps> = ({
  subwayScript,
  sodiumWarningTitle,
  sodiumWarning : sodium_Warning,
  okText,
  moreInfoUrl,
  moreInfoText,
  handleSodiumWarning,
  showModal,
}) => {

  const closePopup = useCallback(() => {
    handleSodiumWarning();
    subwayScript.setCookie('sodiumWarning', 'false', getDaysInYear());
  }, [subwayScript]);

  return (
    <Modal
      testId='modal'
      isShown={showModal}
      isClosebtn={true}
      title={sodiumWarningTitle}
      description={sodium_Warning}
      onButtonClick={closePopup}
      showIcon={true}
    >
      <Button className="popup__button" testAutoId='ok-text' onClick={closePopup}>
        {okText}
      </Button>
      <a className="popup__link" href={moreInfoUrl}>
        {moreInfoText}
      </a>
    </Modal>
  );
};

export default SodiumWarning;
